"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _uniqueActionTypes = _interopRequireDefault(require("crm_data/flux/uniqueActionTypes"));

var _default = (0, _uniqueActionTypes.default)({
  FETCH_SUCCEEDED: 'FETCH_SUCCEEDED',
  FETCH_FAILED: 'FETCH_FAILED',
  ACTION_SUCCEEDED: 'ACTION_SUCCEEDED',
  ACTION_FAILED: 'ACTION_FAILED'
});

exports.default = _default;
module.exports = exports.default;